import { setCookie } from "../commons/HelperFunctions";
import { Settings } from "../config";
import "./uxcore-theme.css";

export const renderConsentManager = (w) => {
  // Consent manager disabled until further notice. Keep in non-prod for testing
  if (Settings.IS_PROD) {
    return;
  }
  setCookie(
    "_policy",
    `{"restricted_market":false,"tracking_market":"explicit"}`
  );
  w.ux = w.ux || {};
  w.ux.data = w.ux.data || {};

  w.ux.privacy = w.ux.privacy || {};
  w.ux.privacy.emulateUtag = true;
  w.ux.privacy.css = Settings.CONSENT_MANAGER_CSS;
  w.ux.privacy.scripts = { 0: [] };

  w.setTimeout(function () {
    var consentEl = document.createElement("script");
    consentEl.async = true;
    consentEl.src = Settings.CONSENT_MANAGER_JS;
    w.document
      .getElementsByTagName("script")[0]
      .parentNode.appendChild(consentEl);
  }, 0);
};
